module.exports = __webpack_public_path__ + "img/card.7c763f5a.png";